import { render, staticRenderFns } from "./112.vue?vue&type=template&id=36bf9531&scoped=true&"
import script from "./112.vue?vue&type=script&lang=js&"
export * from "./112.vue?vue&type=script&lang=js&"
import style0 from "./112.vue?vue&type=style&index=0&id=36bf9531&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bf9531",
  null
  
)

export default component.exports